import { Megaphone, Tag } from "lucide-react";
import { CampaignMedia } from "./CampaignMedia";

export const OfferCardView = ({ kind, kicker, title, body, media, className = "" }) => {
  const Icon = kind === "campaign" ? Megaphone : Tag;
  return (
    <div className={`rounded-[24px] bg-white/85 p-5 text-left shadow-[0_10px_40px_rgba(29,29,31,0.10)] backdrop-blur-xl ${className}`}>
      {media && <CampaignMedia media={media} className="-mx-1 -mt-1 mb-3 block aspect-[2/1] w-[calc(100%+8px)] rounded-[16px]" />}
      <div className="flex items-center gap-2 text-[13px] font-semibold text-[#087568]"><Icon size={15} /> {kicker}</div>
      <p className="mt-1.5 font-display text-[19px] font-bold leading-snug tracking-[-0.02em]" data-testid="offer-title">{title}</p>
      <p className="mt-1 text-[14px] leading-snug text-[#6E6E73]" data-testid="offer-body">{body}</p>
    </div>
  );
};
